import { coupon } from 'app/api/entities/coupon';
import API from 'app/api';
import logError from 'app/error/logError';
import parseResponse from 'app/api/requests/parsers/response';
import { COUPON_QUERY } from 'app/router/constants/paths';

const validateCoupon = (couponCode, sessionId) =>
  API.Crapi.validateCoupon({
    [COUPON_QUERY]: couponCode,
    session_id: sessionId,
  })
    .then(parseResponse)
    .then(coupon)
    .catch(logError);

export { validateCoupon };
